import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ProductoresPage from "./pages/ProductoresPage";
import MainLayout from "./layout/MainLayout";
import TiposCajasPage from "./pages/TiposCajasPage";
import ProcesosPage from "./pages/ProcesosPage";
import DetalleProcesoPage from "./pages/DetalleProcesosPage";
import UserPage from "./pages/UserPage";
import DescargarAppPage from "./pages/DescargarAppPage";
import ReportesSemanalPage from "./pages/ReportesSemanalPage";
import ReporteFinalEnvioPage from "./pages/ReporteFinalEnvioPage";
import InventarioPage from "./pages/InventarioPage";
import PacksPage from "./pages/PacksPage";
import ExportadoresPage from "./pages/ExportadoresPage";
import EnvioInformeResultPage from "./pages/EnvioInformeResultPage";
import ProductosPage from "./pages/ProductosPage";
import ConductoresPage from "./pages/ConductoresPage";
import RoleProtectedRoute from "./components/RoleProtectedRoute";


const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" />;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route
            path="productores"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ProductoresPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="tipos-cajas"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <TiposCajasPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="inventario"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin", "Operador"]}>
                <InventarioPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="packs"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin", "Operador"]}>
                <PacksPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="productos"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ProductosPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="exportadores"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ExportadoresPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="conductores"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ConductoresPage />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="procesos"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ProcesosPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="procesos/:id"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <DetalleProcesoPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="usuarios"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <UserPage />
              </RoleProtectedRoute>
            }
          />
          <Route path="download/app" element={<DescargarAppPage />} />
          <Route
            path="reportes/semanal"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ReportesSemanalPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="reportes/despachos"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin"]}>
                <ReporteFinalEnvioPage />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="informe-resultado"
            element={
              <RoleProtectedRoute allowedRoles={["Administrador", "Super Admin", "Operador"]}>
                <EnvioInformeResultPage />
              </RoleProtectedRoute>
            }
          />

        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
